import { Component } from '@angular/core';
import { FieldsetModule } from 'primeng/fieldset';
import { AvatarModule } from 'primeng/avatar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list-reports',
  imports: [FieldsetModule, AvatarModule],
  templateUrl: './list-reports.component.html'
})
export class ListReportsComponent {
  
  constructor(public router: Router){

  }

  categories = [ 
    // {label:'Produtos', url:'app/reports/products'},
    {label: 'Vendas', url:'app/reports/sales'}, 
    // {label: 'Clientes', url: 'app/reports/customers'}
  ];

  goTo(route: string){
    this.router.navigate([route]);
  }

}
